module.exports = __webpack_public_path__ + "static/media/add-drop.0e92d7c7.svg";